import { Dispatch, ReactNode, SetStateAction } from 'react';
import { useLang } from 'hooks/lang';

import { Button, Column, Row } from 'components/Blocks';
import { ChevronLeftIcon, ChevronRightIcon, SaveIcon } from 'components/Icons';

interface FormWrapperProps {
  children: ReactNode;
  className?: string;

  step: number;
  setStep: Dispatch<SetStateAction<number>>;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  createProject: () => Promise<any>;
  loading?: boolean;
  disabled?: boolean;
}

const MIN_STEP = 1;
const MAX_STEP = 5;

export function FormWrapper({
  children,
  className,
  step,
  setStep,
  disabled,
  loading,
  createProject,
}: FormWrapperProps) {
  const { t } = useLang();

  const goBack = () => {
    setStep((old) => Math.max(old - 1, MIN_STEP));
  };

  const isLast = MAX_STEP === step;

  const action = () => {
    if (isLast) return createProject();

    setStep((old) => Math.min(old + 1, MAX_STEP));
  };

  return (
    <Column className={className} gap="6">
      {children}

      {/* we let step 1 handle next due to the project name validation */}
      {step > MIN_STEP && (
        <Row justifyContent="space-between">
          <Button type="button" variant="outlined" onClick={goBack}>
            <ChevronLeftIcon />
            {t('back')}
          </Button>

          <Button
            className="ml-auto"
            type="button"
            disabled={disabled}
            onClick={action}
            loading={loading}
          >
            {isLast ? t('create') : t('next')}
            {isLast ? <SaveIcon /> : <ChevronRightIcon />}
          </Button>
        </Row>
      )}
    </Column>
  );
}
